import { Col, FormGroup, Input, Label } from "reactstrap";
import { AdharPlaceholder, AllTheAboveInformationIsCorrect, CVVNumber, CardNumber, Expiration, UploadDocumentation } from "../../../../Constant";
import { CardDetailProp } from "../../../../Type/FormLayoutType";

export const CardDataForm = ({ cartInfoForm, getUserData }: CardDetailProp) => {
  const { cardNumber, expirationDate, cvvNumber } = cartInfoForm;

  return (
    <>
      <Col md="4" sm="6" className="mb-3">
        <Label check>{CardNumber}</Label>
        <Input type="text" placeholder={AdharPlaceholder} name="cardNumber" value={cardNumber} onChange={getUserData} />
      </Col>
      <Col md="4" sm="6" className="mb-3">
        <Label htmlFor="validationDates" check>
          {Expiration}
        </Label>
        <Input id="validationDates" type="number" placeholder="xx/xx" name="expirationDate" value={expirationDate} onChange={getUserData} />
      </Col>
      <Col md="4" sm="6" className="mb-3">
        <Label htmlFor="cvvNumber-b" check>
          {CVVNumber}
        </Label>
        <Input id="cvvNumber-b" type="text" name="cvvNumber" value={cvvNumber} onChange={getUserData} />
      </Col>
      <Col md="12" sm="6" className="mb-3">
        <Label htmlFor="formFile2" check>
          {UploadDocumentation}
        </Label>
        <Input id="formFile2" type="file" name="documentationName" onChange={getUserData} />
      </Col>
      <Col xs="12">
        <FormGroup check className="mb-0">
          <Input id="invalidCheck-b" type="checkbox" required />
          <Label className="form-check-label" htmlFor="invalidCheck-b" check>
            {AllTheAboveInformationIsCorrect}
          </Label>
        </FormGroup>
      </Col>
    </>
  );
};
